import React from 'react';
import at from 'lodash/at';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { makeStyles } from '@mui/styles'
import { Trans, useTranslation } from 'react-i18next'
import dataStorage from 'dataStorage';

const filterOptions = createFilterOptions({
  matchFrom: 'start',
  stringify: (option) => option.label,
  trim: true
});

const useStyles = makeStyles((theme) => ({
  paper: {
    height: 230,
    overflow: 'hidden',
    '& ul': {
      maxHeight: '100%'
    }
  }
}))

function AutocompleteField(props) {
  const { label, data = [], helperText, translate = true, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const [touched, error] = at(meta, 'touched', 'error');
  const classes = useStyles();
  const { setValue: setFieldValue } = helper;
  const { value: selectedValue } = field;
  const timeoutId = React.useRef(0)
  const textSearch = React.useRef('')
  const { t } = useTranslation()

  React.useEffect(() => {
    return () => {
      timeoutId.current && clearTimeout(timeoutId.current)
    }
  }, [])

  function _renderHelperText() {
    let text = ''
    if (touched && error) {
      text = error;
    } else if (helperText) {
      text = helperText
    }
    return <Trans values={{ label: dataStorage.translate(label) }}>{text}</Trans>
  }

  const autoSelectOptionByText = () => {
    if (!data || !data.length) return
    const option = data.find(e => e.label.toLowerCase() === (textSearch.current + '').toLowerCase())
    if (option) setFieldValue && setFieldValue(option.value, true)
  }

  function onChangeText(e) {
    textSearch.current = e.target.value.trim() || ''
    timeoutId.current && clearTimeout(timeoutId.current)
    timeoutId.current = window.setTimeout(() => autoSelectOptionByText(), 500)
  }

  function _onChange(event, option, reason) {
    if (reason === 'selectOption') {
      timeoutId.current && clearTimeout(timeoutId.current)
      setFieldValue && setFieldValue(option.value, true)
    }
  }

  return (
    <Autocomplete
      {...field}
      {...rest}
      onChange={_onChange}
      value={selectedValue || null}
      options={data}
      isOptionEqualToValue={(option, select) => {
        return select && option.value === select
      }}
      classes={{ paper: classes.paper }}
      getOptionLabel={item => {
        if (!item) return ''
        if (item.label) {
          return translate ? t(item.label) : item.label
        } else {
          const option = data.find(e => e.value === item)
          return translate ? t(option?.label || item) : (option?.label || item)
        }
      }}
      filterOptions={filterOptions}
      id="disable-clearable"
      disableClearable
      renderInput={(params) => {
        return <TextField
          onBlur={() => helper.setTouched(true, true)}
          name={'password'}
          {...params}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'off',
            form: {
              autocomplete: 'off'
            }
          }}
          required={rest.required}
          value={(selectedValue && selectedValue.label) || textSearch.current || ''}
          variant="outlined"
          onChange={onChangeText}
          error={touched && error && true}
          helperText={_renderHelperText()}
          label={<Trans>{label}</Trans>}
          type="text" />
      }}
    />
  );
}

export default AutocompleteField;
